import { createMongoAbility, AbilityBuilder } from "@casl/ability";
export const appAbility = createMongoAbility([]);
function grant(can, action, subjects) {
    subjects.forEach((subject) => can(action, subject));
}
const ROLE_DEFINITIONS = {
    platform_owner: (can) => {
        can("manage", "all");
    },
    super_admin: (can) => {
        can("manage", "all");
    },
    admin: (can) => {
        can("manage", "all");
    },
    org_admin: (can) => {
        can("manage", "all");
    },
    provider_owner: (can) => {
        grant(can, "manage", [
            "Organization",
            "OrganizationMember",
            "OrganizationBankAccount",
            "Provider",
            "Service",
            "Calendar",
            "Conversation",
            "Notification",
            "Package",
            "Review",
        ]);
        grant(can, "read", [
            "Category",
            "Role",
            "Reservation",
            "Dashboard",
            "AIAssistant",
            "OrganizationBilling",
            "PaymentOperations",
        ]);
    },
    provider_admin: (can) => {
        grant(can, "manage", [
            "OrganizationMember",
            "Provider",
            "Service",
            "Calendar",
            "Conversation",
            "Notification",
            "Package",
            "Review",
        ]);
        grant(can, "read", [
            "Category",
            "Organization",
            "Role",
            "Reservation",
            "Dashboard",
            "AIAssistant",
            "OrganizationBilling",
            "PaymentOperations",
        ]);
    },
    provider_staff: (can) => {
        grant(can, "read", [
            "Category",
            "Organization",
            "Provider",
            "Role",
            "Service",
            "Calendar",
            "Reservation",
            "Dashboard",
            "Package",
            "AIAssistant",
            "Review",
            "PaymentOperations",
        ]);
        can("manage", "Conversation");
        can("manage", "Notification");
    },
    concierge_owner: (can) => {
        can("manage", ["Provider", "Service", "Calendar"]);
        grant(can, "manage", [
            "Organization",
            "OrganizationMember",
            "OrganizationBankAccount",
            "Customer",
            "Itinerary",
            "Conversation",
            "Notification",
        ]);
        grant(can, "read", [
            "Category",
            "ProviderCatalog",
            "Role",
            "Service",
            "Dashboard",
            "AIAssistant",
            "OrganizationBilling",
            "PaymentOperations",
            "Review",
        ]);
    },
    concierge_admin: (can) => {
        can("manage", ["Provider", "Service", "Calendar"]);
        grant(can, "manage", [
            "OrganizationMember",
            "Customer",
            "Itinerary",
            "Conversation",
            "Notification",
        ]);
        grant(can, "read", [
            "Category",
            "Organization",
            "ProviderCatalog",
            "Role",
            "Service",
            "Dashboard",
            "AIAssistant",
            "OrganizationBilling",
            "PaymentOperations",
            "Review",
        ]);
    },
    concierge_staff: (can) => {
        grant(can, "read", [
            "Category",
            "Organization",
            "ProviderCatalog",
            "Role",
            "Service",
            "Dashboard",
            "AIAssistant",
            "Review",
            "PaymentOperations",
        ]);
        grant(can, "manage", [
            "Customer",
            "Itinerary",
            "Conversation",
            "Notification",
        ]);
    },
    concierge: (can) => {
        can("read", "Category");
        can("read", "ProviderCatalog");
        can("read", "Role");
        can("read", "Service");
        can("read", "Review");
        can("read", "PaymentOperations");
        can("manage", "Customer");
        can("manage", "Itinerary");
        can("read", "Dashboard");
        can("read", "AIAssistant");
        can("read", "PaymentOperations");
        can("manage", "Conversation");
        can("manage", "Notification");
    },
    proveedor: (can) => {
        can("read", "Category");
        can("read", "Role");
        can("read", "Service");
        can("read", "Review");
        can("manage", "Service");
        can("read", "Calendar");
        can("manage", "Calendar");
        can("read", "Reservation");
        can("read", "Dashboard");
        can("read", "AIAssistant");
        can("read", "PaymentOperations");
        can("manage", "Conversation");
        can("manage", "Notification");
    },
    provider: (can) => {
        can("read", "Category");
        can("read", "Role");
        can("read", "Service");
        can("read", "Review");
        can("manage", "Service");
        can("read", "Calendar");
        can("manage", "Calendar");
        can("read", "Reservation");
        can("read", "Dashboard");
        can("read", "AIAssistant");
        can("manage", "Conversation");
        can("manage", "Notification");
    },
};
// =============================================================================
// FACTORY
// =============================================================================
/**
 * Builds a new AppAbility by merging the rules of all provided role keys.
 *
 * - hasGlobalPlatformContext=true → can('manage', 'all') regardless of roleKeys
 * - Unknown / invalid role keys are silently skipped (no permissions added)
 * - Empty roleKeys with hasGlobalPlatformContext=false → no permissions (deny by default)
 */
export function defineRulesFor(roleKeys, hasGlobalPlatformContext) {
    const { can, build } = new AbilityBuilder(createMongoAbility);
    if (hasGlobalPlatformContext) {
        can("manage", "all");
        return build();
    }
    roleKeys.forEach((key) => {
        const define = ROLE_DEFINITIONS[key];
        if (define) {
            define(can);
        }
    });
    return build();
}
